/**
 * iter538 · Reviewer Mode — Apple App Review reviewer helper.
 *
 * Single source of truth for detecting Apple's App Review reviewer
 * account. Delete this file (and the one call site in
 * AthleteCareerHomePage.js) and the surface goes back to normal.
 *
 * Rules:
 *   • ONLY matches the exact `applereview@flythouse.com` email.
 *   • Case-insensitive + trims whitespace so "APPLEREVIEW@flythouse.com "
 *     still resolves (avoids a bad reviewer typo experience).
 *   • Never trusts any other flag on the user object — email match only,
 *     so nothing else in the DB can accidentally trigger reviewer UI
 *     for a real athlete.
 */

const REVIEWER_EMAIL = 'applereview@flythouse.com';

export const isReviewerAccount = (user) => {
  const email = (user?.email || '').trim().toLowerCase();
  return email === REVIEWER_EMAIL;
};
